import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface AccountProps {
  providerAccountFormPayload: UseFormPayload,
}

const Account = (props: AccountProps) => {
  const { providerAccountFormPayload } = props

  const {
    entityState: {
      enable_account_lock,
      notes,
      terms,
    },
    errors,
    handlers,
  } = providerAccountFormPayload

  return (
    <DashboardModule title="Account">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Trading Terms">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="terms"
              value={terms}
              {...handlers}
            >
              <option value="">Select Trading Terms</option>
              <option value="cash">Cash</option>
              <option value="7">7 Days</option>
              <option value="14">14 Days</option>
              <option value="30">30 Days</option>
              <option value="60">60 Days</option>
              <option value="90">90 Days</option>
            </select>
          </Form.Field>

          <Form.Field label="Enabled Account Lock">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              data-value-type="boolean"
              name="enable_account_lock"
              value={enable_account_lock}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Field errorMessage={errors.notes} label="Client Notes" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <textarea name="notes" style={{ minHeight: 100 }} value={notes} {...handlers} />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default Account
